export default __webpack_public_path__ + "static/media/hat2.5d4dbcbf.png";